import { createBrowserHistory } from "history";
import { config } from "src/config/config";

export default createBrowserHistory({
  basename: config.appSubdomain
});



// WEBPACK FOOTER //
// ./src/plugins/history.ts